module.exports = "data:image/gif;base64,R0lGODlhBwAHAIABAAAAAP///yH5BAEAAAEALAAAAAAHAAcAAAIMjGGJmMH9mHQ0AlYAADs="


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/assets/tinymce/skins/lightgray/img/anchor.gif
// module id = ../../../../../src/assets/tinymce/skins/lightgray/img/anchor.gif
// module chunks = styles